export default __webpack_public_path__ + "static/cross-platform-header-1af77e78848d1027e55067717a42ddca.jpg";